import { render, staticRenderFns } from "./bookinsight-comment.vue?vue&type=template&id=6c530e81&"
import script from "./bookinsight-comment.vue?vue&type=script&lang=js&"
export * from "./bookinsight-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports